// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Bulma$GearCalculator = require("./Bulma.bs.js");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Tag(Props) {
  var children = Props.children;
  var className = Props.className;
  var $staropt$star = Props.isPrimary;
  var $staropt$star$1 = Props.isLink;
  var $staropt$star$2 = Props.isInfo;
  var $staropt$star$3 = Props.isSuccess;
  var $staropt$star$4 = Props.isWarning;
  var $staropt$star$5 = Props.isDanger;
  var $staropt$star$6 = Props.isDelete;
  var $staropt$star$7 = Props.isNormal;
  var $staropt$star$8 = Props.isMedium;
  var $staropt$star$9 = Props.isLarge;
  var isPrimary = $staropt$star !== undefined ? $staropt$star : false;
  var isLink = $staropt$star$1 !== undefined ? $staropt$star$1 : false;
  var isInfo = $staropt$star$2 !== undefined ? $staropt$star$2 : false;
  var isSuccess = $staropt$star$3 !== undefined ? $staropt$star$3 : false;
  var isWarning = $staropt$star$4 !== undefined ? $staropt$star$4 : false;
  var isDanger = $staropt$star$5 !== undefined ? $staropt$star$5 : false;
  var isDelete = $staropt$star$6 !== undefined ? $staropt$star$6 : false;
  var isNormal = $staropt$star$7 !== undefined ? $staropt$star$7 : false;
  var isMedium = $staropt$star$8 !== undefined ? $staropt$star$8 : false;
  var isLarge = $staropt$star$9 !== undefined ? $staropt$star$9 : false;
  return React.createElement("span", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "tag",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* :: */[
                        Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isPrimary, isPrimary),
                        /* :: */[
                          Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isLink, isLink),
                          /* :: */[
                            Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isInfo, isInfo),
                            /* :: */[
                              Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isSuccess, isSuccess),
                              /* :: */[
                                Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isWarning, isWarning),
                                /* :: */[
                                  Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isDanger, isDanger),
                                  /* :: */[
                                    Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isNormal, isNormal),
                                    /* :: */[
                                      Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isMedium, isMedium),
                                      /* :: */[
                                        Classnames$GearCalculator.ifTrue(Bulma$GearCalculator.Helpers.isLarge, isLarge),
                                        /* :: */[
                                          Classnames$GearCalculator.ifTrue("is-delete", isDelete),
                                          /* [] */0
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ])
            }, children !== undefined ? Caml_option.valFromOption(children) : null);
}

var make = Tag;

exports.make = make;
/* react Not a pure module */
